import React, { FC } from "react";
import SVG from 'react-inlinesvg';

interface IconProps {
  id?: string;
  name: string;
  className?: string;
  title?: string;
  onClick?: (event: any) => void;
};

const Icon: FC<IconProps> = ({ id, name, title, onClick, className = '' }) => {
  return (
    <SVG 
      id={id}
      onClick={onClick}
      cacheRequests={true}
      className={`svg-icon ${className}`.trim()}
      src={`/svg/${name}.svg`}
      uniqueHash="nkGedVx5uH78g"
      title={title}
      uniquifyIDs={true}
    />
  )
};

export default Icon;
